import { SettingsSectionHeader } from '@/components/settings/section-header';
import { WebhooksV2Page } from '@/components/settings/webhooks-v2/webhooks-v2-page';
import { Layout } from '@/components/ui/design-system';
import { useTranslation } from '@/hooks/use-translation';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/webhooks')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('desktop_ui');

  return (
    <Layout isScrollable contentClassName="max-w-[960px] px-20 !pt-0 pb-30">
      <section className="flex flex-col gap-4">
        <SettingsSectionHeader
          title={t('settings.sidebar.webhooks')}
          description={t('settings.webhooks.description')}
        />
        <WebhooksV2Page />
      </section>
    </Layout>
  );
}
